'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'narwhal';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f6fe';
var svgPathData = 'M587.4 210.5c32.5 31.9 52.6 76.4 52.6 125.5 0 97.2-78.8 176-176 176l-232 0c-54.1 0-102-26.9-130.9-68-15.4-21.9-25.5-47.9-28.3-76-.5-5.3-.8-10.6-.8-16l0-92-72-36 0-128 96 48 96-48 0 128-72 36 0 108 1-.8c13.3-10.5 80.7-63.6 202.2-159.3 39.4-31 88-47.9 138.2-47.9l2.6 0c16.6 0 32.6 2.3 47.9 6.6L640 0 587.4 210.5zM232 464l232 0c70.7 0 128-57.3 128-128S534.7 208 464 208l-2.6 0c-39.4 0-77.6 13.2-108.5 37.6l-203.2 160.1-10.8 8.5C159 444.2 193.2 464 232 464zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faNarwhal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;